export default __webpack_public_path__ + "media/images/images/datatables/images/sort_asc_disabled-27ac5d1bc294b1fae0564fe461a6304d.png";